import EfLink from '@elem/ui/ef-link';
import { Popover } from 'antd';
import styled from './index.module.scss';
import { Icon1, Icon2, Icon3, Icon4, AskIcon } from './icons';
import { useGlobal } from '@/utils/useGlobal';
import { Button } from '@/components/UI';
import gtm from '@/utils/gtm';

const HowWorksNew = ({ redirectUrl = '', isLogin = false }: { redirectUrl: string; isLogin: boolean }) => {
    const { useLang, useRouter } = useGlobal();
    const router = useRouter();
    const { t } = useLang('referral.works');

    const redirectLink = `/${router.locale}/ecocredits`;

    return (
        <div className={`${styled.how_works}`}>
            <div className="works_content">
                <div className="title">{t('title')}</div>
                <div className="desc">{t('desc')}</div>
                <div className="link_wrapper">
                    <EfLink
                        href={redirectLink}
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'jump_button',
                            position: 'Join EcoCredits Rewards Program',
                            button_name: t('link'),
                            url: redirectLink,
                        }}
                        className="works_link"
                        target="_blank"
                    >
                        {t('link')}
                    </EfLink>
                </div>
                <div className="info_content">
                    <div className="info_item">
                        <div className="img img1">
                            <Icon1 />
                        </div>
                        <div className="item_title">{t('title1')}</div>
                        <div className="item_desc">{t('desc1')}</div>
                    </div>
                    <div className="info_item">
                        <div className="img img2">
                            <Icon2 />
                        </div>
                        <div className="item_title">{t('title2')}</div>
                        <div className="item_desc">{t('desc2')}</div>
                    </div>
                    <div className="info_item">
                        <div className="img img3">
                            <Icon3 />
                        </div>
                        <div className="item_title">{t('title3')}</div>
                        <div className="item_desc">{t('desc3')}</div>
                    </div>
                    <div className="info_item">
                        <div className="img img4">
                            <Icon4 />
                        </div>
                        <div className="item_title">
                            {t('title4')}
                            <Popover
                                content={
                                    <>
                                        <p>{t('tips1')}</p>
                                        <p>{t('tips2')}</p>
                                    </>
                                }
                                trigger="hover"
                                placement="top"
                                overlayClassName="custom-popover"
                                getPopupContainer={(triggerNode) => triggerNode.parentElement || document.body}
                                align={{
                                    offset: [0, -8],
                                }}
                            >
                                <div className="ask-icon-wrapper">
                                    <AskIcon />
                                </div>
                            </Popover>
                        </div>
                        <div className="item_desc">{t('desc4')}</div>
                    </div>
                </div>
                {!isLogin && (
                    <div style={{ textAlign: 'center' }}>
                        <Button
                            className={`refer-btn`}
                            onClick={() => {
                                const a = document.createElement('a');
                                a.href = redirectUrl;
                                a.target = '_blank';
                                a.rel = 'noopener noreferrer';
                                document.body.appendChild(a);
                                a.click();
                                document.body.removeChild(a);

                                try {
                                    gtm.push({
                                        event: 'uaEvent',
                                        event_name: 'jump_button',
                                        position: 'Join EcoCredits Rewards Program',
                                        button_name: t('btn'),
                                        url: redirectUrl,
                                    });
                                } catch (e) {
                                    console.log(e);
                                }
                            }}
                        >
                            {t('btn')}
                        </Button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default HowWorksNew;
